import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from "../../../admin-core/constants";
import { snapDownToMoi, snapUpToMoi, formatMoiQty } from '../../../shared/utils/snap-to-moi';
import {FormAutofocusDirective} from '../../../shared/directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  standalone: false,
  selector: 'app-transfer-product-modal',
  templateUrl: './transfer-product-modal.component.html',
  // styleUrls: ['./transfer-product-modal.component.css', '../../../../app.component.css']
  styleUrls: ['./transfer-product-modal.component.css', '../../../app.component.css']
})
export class TransferProductModalComponent implements OnInit {

  @Input() size: any;
  @Input() uom: any;
  @Input() product: any;
  @Input() showSplitStockOption = true;
  @Input() disableSplitStock = false;
  @Input() availableQty: any;
  stockType: any = '1';
  splitStock: any;
  submitted: boolean = false;
  suggestedQuantity: any;
  clickesQuantity: any;
  isQuantityTooHigh: boolean = false;
  constructor(public ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onStockTypeChange() {
    if (this.stockType === '1') {
      this.splitStock = null;
      this.suggestedQuantity = null;
    } else if (this.stockType == 2 && this.availableQty != null && +this.availableQty < +this.size) {
      this.splitStock = +this.availableQty > 0 ? +this.availableQty : null;
      this.onSplitStockChange();
    }
  }

  transfer() {
    this.submitted = true;
    if (!this.stockType || (this.stockType == 2 && (!this.splitStock || +this.splitStock >= this.size || this.splitStock == 0))) return;
    this.ngbActiveModal.close({ quantity: this.size, splitStock: this.splitStock });
  }

  checkDecimalDot(e: any) {
    let charCode = (e.which) ? e.which : e.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
  }

  calculateModulo(dividend: number, divisor: number): number {
    
    if (!dividend || !divisor || divisor === 0) {
      return 0;
    }

    // Compliant when the quantity is (within FP tolerance) a whole multiple
    // of moi. Comparing the ratio to its nearest integer avoids the `%`
    // floating-point error, e.g. 28.9809 % 0.2477 returns ~0.2477 not 0.
    const ratio = dividend / divisor;
    const rounded = Math.round(ratio);
    return Math.abs(ratio - rounded) < 1e-9 ? 0 : dividend % divisor;
  }

  onSplitStockChange() {
    this.suggestedQuantity = null;
    this.isQuantityTooHigh = false;
    if (this.product && this.splitStock) {
      const quantity = +this.splitStock;

      if (quantity > +this.size) {
        this.isQuantityTooHigh = true;
        return;
      }

      const moi = +this.product.moi;
      const moq = +this.product.moq;

      if (quantity > 0 && moi > 0 && this.calculateModulo(quantity, moi) !== 0) {
        const maxAllowed = this.availableQty != null
          ? Math.min(+this.size, +this.availableQty)
          : +this.size;
        // Full-precision moi multiples (console displays 4dp).
        const floorQuantity: number = snapDownToMoi(quantity, moi);
        let calcQuantity: number = floorQuantity;
        if (floorQuantity < quantity) {
          const ceilQuantity: number = snapUpToMoi(quantity, moi);
          // Only round up if the ceil multiple does not exceed the available qty
          calcQuantity = ceilQuantity <= maxAllowed ? ceilQuantity : floorQuantity;
        }
        // Only suggest if the result is a positive valid quantity
        if (calcQuantity > 0) {
          this.clickesQuantity = formatMoiQty(calcQuantity, 4);
          if (quantity != this.clickesQuantity) {
            this.suggestedQuantity = this.clickesQuantity;
          }
        }
      }
    }
  }

  checkQuantity() {
    if (this.suggestedQuantity) {
      this.splitStock = this.suggestedQuantity;
      this.suggestedQuantity = null;
      this.onSplitStockChange();
    }
  }

  protected readonly constants = Constants;
}
